export default __webpack_public_path__ + "static/media/jquery.2cdd0b1e.svg";